/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const hide_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.565 5.57A9.685 9.685 0 0 0 12 5.25C7.969 5.183 3.8 8 1.179 10.885a1.663 1.663 0 0 0 0 2.226c.87.958 1.923 1.922 3.095 2.776m15.451-7.776a20.62 20.62 0 0 1 3.099 2.774 1.663 1.663 0 0 1 0 2.226C20.258 15.935 16.1 18.817 12 18.748a9.736 9.736 0 0 1-2.6-.325M11.882 8.25a3.75 3.75 0 0 0-3.63 3.632m7.496.234a3.75 3.75 0 0 1-3.63 3.63M22 2 2 22"
    />
  </svg>
)
export default hide_medium
